import React from 'react';
import { memberCashLimitType } from '../../types';
import DateTime, { LONG_DATE } from '../DateTime';
import Number from '../Number';

MemberCashLimitRow.propTypes = {
    cashLimit: memberCashLimitType.isRequired,
};

function MemberCashLimitRow(props) {
    const {
        cashLimit,
    } = props;
    return (
        <div className="detail-list-row">
            <div className="cash-limit-cell member-cash-limit-row--clearing-house">{cashLimit.clearingHouse.code}</div>
            <div className="cash-limit-cell member-cash-limit-row--clearing-house-time-zone">{cashLimit.clearingHouse.timeZone.ID}</div>
            <div className="cash-limit-cell member-cash-limit-row--currency">{cashLimit.currency.code}</div>
            <div className="cash-limit-cell member-cash-limit-row--initial-cash-limit">
                <Number value={cashLimit.initialCashLimit} fractionDigits={2} />
            </div>
            <div className="cash-limit-cell member-cash-limit-row--current-cash-limit">
                <Number value={cashLimit.currentCashLimit} fractionDigits={2} />
            </div>
            <div className="cash-limit-cell member-cash-limit-row--current-auction-day">
                <DateTime value={cashLimit.currentAuctionDay} format={LONG_DATE} />
            </div>
            <div className="cash-limit-cell member-cash-limit-row--next-auction-day-initial-cash-limit">
                <Number value={cashLimit.nextAuctionDayInitialCashLimit} fractionDigits={2} />
            </div>
            <div className="cash-limit-cell member-cash-limit-row--next-auction-day">
                <DateTime value={cashLimit.nextAuctionDay} format={LONG_DATE} />
            </div>
        </div>
    );
}

export default MemberCashLimitRow;
